
<template>
  <v-navigation-drawer
    dark
    touchless
    v-model="isVisible"
    :width="220"
    color="secondary"
  >
    <v-list class="pa-0">
      <template
        v-for="item in items"
        :key="item.id"
      >
        <v-list-item
          v-if="item.navigationVisible"
          link
          :class="['rounded-0', item.id === current ? 'sm__current-item' : '']"
          @click="$emit('click-item', item.id)"
        >
          <template #prepend>
            <sm-badge
              dot
              :visible="item.badgeVisible"
              class="pl-2 mr-3"
            >
              <v-icon
                dark
                style="opacity:1"
              >
                {{ item.icon }}
              </v-icon>
            </sm-badge>
          </template>
          <div>
            <v-list-item-title>
              <sm-text
                format="sm__caption"
                :text="item.name"
              />
            </v-list-item-title>
          </div>
        </v-list-item>
        <v-divider />
      </template>
    </v-list>
  </v-navigation-drawer>
</template>

<script lang="ts">
import type { NavigationItems } from '@/dtos/navigation'
import { Vue, Component, Prop } from 'vue-facing-decorator'
import { defineAsyncComponent, PropType } from 'vue'

@Component({
  components: {
    SmText: defineAsyncComponent(() => import('@/components/atoms/SmText.vue')),
    SmBtnText: defineAsyncComponent(() => import('@/components/atoms/SmBtnText.vue')),

    SmBadge: defineAsyncComponent(() => import('@/components/molecules/SmBadge.vue'))
  },
  emits: ['click-item']
})
export default class SmDrawer extends Vue {
  @Prop({ type: Object as PropType<NavigationItems>, required: true })
  private readonly items!: NavigationItems

  @Prop({ type: String, required: true })
  private current!: string

  private isVisible = true
}
</script>

<style scoped>
.sm__current-item {
  background-color: #00A2D5;
}
/** template v-slot:prependの不要な要素を非表示にする */
:deep(.v-list-item__spacer) {
  display: none !important;
}
</style>
